import '../scss/style.scss';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', function () {
    //open menu mobile

    if (document.querySelector('.open-mobile')) {
        const openMobileLink = document.querySelector('.open-mobile');
        const closeMobileLink = document.querySelector('.close-mobile');
        const navMain = document.getElementById('nav-main');

        openMobileLink.addEventListener('click', function (e) {
            e.preventDefault()
            navMain.classList.remove('lg:hidden');
            navMain.classList.add('lg:flex');
        });

        closeMobileLink.addEventListener('click', function (e) {
            e.preventDefault()
            navMain.classList.remove('lg:flex');
            navMain.classList.add('lg:hidden');
        });
    }

    //acordean

    const headers = document.querySelectorAll('.accordion-header');
    const closeButtons = document.querySelectorAll('.close-accordion');

    headers.forEach(header => {
        header.addEventListener('click', function () {
            const content = this.nextElementSibling;
            const isVisible = content.style.display === 'block';
            document.querySelectorAll('.accordion-content').forEach(c => c.style.display = 'none');
            document.querySelectorAll('.accordion-header').forEach(h => h.classList.remove('active'));
            if (!isVisible) {
                content.style.display = 'block';
                this.classList.add('active');
            }
        });
    });

    closeButtons.forEach(button => {
        button.addEventListener('click', function (event) {
            const content = this.parentElement;
            const header = content.previousElementSibling;
            content.style.display = 'none';
            header.classList.remove('active');
            event.stopPropagation();
        });
    });

    //slider rules
    var swiper = new Swiper(".swiper-rules", {
        modules: [Navigation, Pagination],
        slidesPerView: 2,
        spaceBetween: 30,
        pagination: {
            el: ".slider-rules-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".slider-rules-next",
            prevEl: ".slider-rules-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            769: {
                slidesPerView: 2,
            },
            1025: {
                slidesPerView: 2,
            }
        }
    });

    //slider awards

    var swiper = new Swiper(".swiper-awards", {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-awards-next",
            prevEl: ".swiper-awards-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            769: {
                slidesPerView: 1,
            },
            1025: {
                slidesPerView: 1,
            }
        }
    });

    const modal = document.getElementById('modal-search');
    const openModalButton = document.getElementById('openModalButton');
    const closeModalButton = document.getElementById('closeModalButton');
    const modalInput = document.querySelector('.modalInput');
    const modalContent = document.querySelector('.search-input-modal'); // Selecciona el contenido del modal

    openModalButton.addEventListener('click', function (event) {
        event.stopPropagation(); // Previene que el clic se propague al contenedor de la ventana
        modal.classList.remove('hidden');
        setTimeout(() => {
            modalInput.focus(); // Establecer foco en el input después de abrir el modal
        }, 200); // Retraso para asegurar que el modal esté completamente visible
    });

    closeModalButton.addEventListener('click', function (event) {
        event.stopPropagation(); // Previene que el clic se propague al contenedor de la ventana
        modal.classList.add('hidden');
    });

    // Cerrar el modal al hacer clic fuera del contenido del modal
    window.addEventListener('click', function (event) {
        if (!modalContent.contains(event.target) && !openModalButton.contains(event.target)) {
            modal.classList.add('hidden');
        }
    });

    // Single Post Copy To Clipboard
    if(document.querySelector('.copy-to-clipboard')) {
        const copy = document.querySelector('.copy-to-clipboard');

        copy.addEventListener('click', (e) => {
            e.preventDefault();

            const currentUrl = window.location.href;
            navigator.clipboard.writeText(currentUrl)
                .then(() => {
                    const text = document.querySelector('.copied-success-text');
                    text.classList.add('active');

                    setTimeout(() => {
                        text.classList.remove('active');
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Error al copiar URL al portapapeles: ', error);
                });
        });
    }

    const fade = document.querySelectorAll('.fade');
    const zoom = document.querySelectorAll('.scale-element');
    const mouse = document.querySelectorAll('.mouse');
    const elements2 = document.querySelectorAll('.elements2');
    const elements3 = document.querySelectorAll('.elements3');
    const elements4 = document.querySelectorAll('.elements4');
    const elements5 = document.querySelectorAll('.elements5');
    const elements6 = document.querySelectorAll('.elements6');
    const scaleScroll = document.querySelectorAll('.scale-scroll');

    fade.forEach((f, index) => {
        gsap.fromTo(f, 
            {
                opacity: 0
            },
            {
                opacity: 1,
                duration: .3,
                ease: "power1.out",
                delay: index * .3
            }
        );
    });

    elements2.forEach((el2, index) => {
        gsap.fromTo(el2, 
            {
                y: 100,
                opacity: 0
            },
            {
                scrollTrigger: {
                    trigger: el2,
                    start: 'top 90%',
                    end: 'top 20%',
                    scrub: false,
                    markers: false,
                    toggleActions: 'play none play reverse'
                },
                y: 0,
                opacity: 1,
                duration: .4,
                ease: "power1.out",
                delay: index * .4
            }
        );
    });

    scaleScroll.forEach((scaleS, index) => {
        gsap.fromTo(scaleS, 
            {   
                y: -100,
                scale: .3,
                opacity: 0
            },
            {
                scrollTrigger: {
                    trigger: scaleS,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: false,
                    markers: false,
                    toggleActions: 'play none play reverse'
                },
                y: 0,
                scale: 1,
                opacity: 1,
                duration: 1,
                delay: index * .7
            }
        );
    });

    zoom.forEach((z) => {
        gsap.fromTo(z, 
            {
                scale: 1
            },
            {
                scrollTrigger: {
                    trigger: z,
                    start: 'top 90%',
                    end: 'top -100%',
                    scrub: true,
                    markers: false,
                    toggleActions: 'play none play reverse'
                },
                scale: 1.8,
                duration: 1,
                ease: "power2.out"
            }
        );
    });

    elements3.forEach((el3, index) => {
        gsap.fromTo(el3, 
            {
                y: 100,
                opacity: 0
            },
            {
                scrollTrigger: {
                    trigger: el3,
                    start: 'top 95%',
                    end: 'top 20%',
                    scrub: false,
                    markers: false,
                    toggleActions: 'play none play reverse'
                },
                y: 0,
                opacity: 1,
                duration: .4,
                ease: "power1.out",
                delay: index * .3
            }
        );
    });

    elements4.forEach((el4, index) => {
        gsap.fromTo(el4, 
            {
                x: 150,
            },
            {
                scrollTrigger: {
                    trigger: el4,
                    start: 'top 95%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false,
                    toggleActions: 'play none play reverse'
                },
                x: 0,
                duration: .4,
                ease: "power2.out",
                delay: index * .3
            }
        );
    });

    elements5.forEach((el5, index) => {
        gsap.fromTo(el5, 
            {
                y: 100,
                opacity: 0
            },
            {
                scrollTrigger: {
                    trigger: el5,
                    start: 'top bottom',
                    end: 'top 20%',
                    scrub: false,
                    markers: false,
                    toggleActions: 'play none play reverse'
                },
                y: 0,
                opacity: 1,
                duration: .4,
                ease: "power1.out",
                delay: index * .3
            }
        );
    });

    elements6.forEach((el6, index) => {
        gsap.fromTo(el6, 
            {
                y: 100,
                opacity: 0
            },
            {
                scrollTrigger: {
                    trigger: el6,
                    start: 'top bottom',
                    end: 'top top',
                    scrub: false,
                    markers: false,
                    toggleActions: 'play none play reverse'
                },
                y: 0,
                opacity: 1,
                duration: .4,
                ease: "power2.out",
                delay: index * .3
            }
        );
    });

    document.addEventListener('mousemove', (e) => {
        let mouseX = e.clientX;
        let mouseY = e.clientY;
    
        mouse.forEach((m, index) => {
            let speed = 0.003 * (index + 1);
    
            gsap.to(m, {
                x: (mouseX - window.innerWidth / 2) * speed,
                y: (mouseY - window.innerHeight / 2) * speed,
                ease: "power2.out",
                duration: 0.8,
            });
        });
    });
})